import styled from '@emotion/styled'
import { IconPremium } from '../../../icons'
import { breakpoint, calcRem, fonts } from '../../../__styling'

export const StyledEpaperCollectionPaperMainContainer = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        overflowX: 'scroll',
        gap: calcRem(8),
        justifyContent: 'flex-start',
        [breakpoint('lg')]: {
            display: 'flex',
            flexWrap: 'wrap',
            overflowX: 'visible',
        },
    }),
)

export const StyledEpaperCollectionPaperContainer = styled('div')(
    ({ theme }) => ({
        [breakpoint('lg')]: {
            flex: `0 1 ${calcRem(167)}`,
        },
    }),
)

export const StyledLatestEditionContainer = styled('div')(({ theme }) => ({}))

export const StyledEpaperCollectionPaperWrapper = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',

        [breakpoint('lg')]: {
            display: 'flex',
            alignItems: 'start',
        },
    }),
)

export const StyledEpaperCollectionPaperSpanText = styled('text')(
    ({ theme }) => ({
        fontSize: calcRem(20),
        fontFamily: fonts.designSystem.sansSerif,
        fontWeight: 500,

        [breakpoint('lg')]: {
            fontSize: calcRem(16),
            lineHeight: calcRem(20),
        },
    }),
)

export const StyledEpaperCollectionPapersStyledImg = styled('img')(
    ({ theme }) => ({
        width: calcRem(268),
        height: calcRem(380),
        filter: 'brightness(0.95)',
        [breakpoint('lg')]: {
            maxWidth: '100%',
            height: 'auto',
        },
    }),
)

export const StyledIconPremium = styled(IconPremium)(() => ({
    width: calcRem(20),
    height: calcRem(20),
    verticalAlign: 'text-bottom',
    marginRight: calcRem(1),
    marginTop: calcRem(1),
}))

export const StyledDate = styled('div')(() => ({
    [breakpoint('lg')]: {
        display: 'flex',
        flexFlow: 'column',
    },
}))

export const StyledDateSpan = styled('span')(() => ({
    [breakpoint('lg')]: {
        width: '100%',
    },
}))
